var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 137,
    viewBox: "0 0 145 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.464936 65.8587L41.8069 134.983C42.5249 136.198 43.9472 136.806 45.3142 136.502L50.7823 135.3L78.7992 116.908L100.036 125.897C100.658 126.159 101.362 126.228 102.025 126.077L107.217 124.917L12.202 54.5911L1.51434 61.4124C0.0230417 62.379 -0.44641 64.3398 0.464936 65.8587Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8109 132.953L5.20079 64.1326C3.97186 62.0338 4.62085 59.3412 6.67829 58.057L98.4757 0.683602C100.616 -0.655801 103.447 0.0346143 104.717 2.21632L144.389 70.084C145.604 72.1691 144.955 74.8478 142.911 76.132L114.024 94.3313C112.795 95.1046 112.022 96.4302 111.939 97.88L110.696 120.76C110.531 123.909 107.23 125.911 104.358 124.599L84.6259 115.582C83.2313 114.947 81.5881 115.071 80.3039 115.914L52.1213 134.417C49.981 135.839 47.1089 135.162 45.8109 132.953Z",
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.000416924,
    y1: 95.5906,
    x2: 107.227,
    y2: 95.5906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7688,
    stopColor: "#a78bfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9774,
    stopColor: "#C8BCF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 4.57155,
    y1: 67.5815,
    x2: 145.006,
    y2: 67.5815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27292A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 137,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBlue);
export default __webpack_public_path__ + "static/media/message_blue.3c923bb69682d07ce3d8f9d0b9ee67e6.svg";
export { ForwardRef as ReactComponent };